import {Box, Grid} from '@material-ui/core'
import {Container} from 'app/modules/Cities/Pages/EditCitie/styles'
import _t, {_} from 'i18n'
import {QRCodeCanvas} from 'qrcode.react'
import React, {useEffect, useMemo, useRef, useState} from 'react'
import {Button} from 'react-bootstrap'

import useShowcaseSnippets from './useShowcaseSnippets'

const ShowcaseGenerator = ({onGenerateShowcase, submiting, showcaseUrl, name}) => {
  const [url, setUrl] = useState('')
  const [language, setLanguage] = useState('pt')
  const snippets = useShowcaseSnippets(url)
  const canvasRef = useRef(null)

  useEffect(
    function () {
      console.log(showcaseUrl)

      setUrl(
        language !== 'en' || !showcaseUrl ? showcaseUrl?.replace('-en', '') : showcaseUrl?.replace('.html', '-en.html'),
      )
    },
    [language, showcaseUrl],
  )

  const onDownload = () => {
    const canvas = canvasRef.current?.querySelector('canvas')
    if (!canvas) return
    const dataUrl = canvas.toDataURL('image/png')
    const a = document.createElement('a')
    const suffix = language === 'en' ? ` ${_`(Inglês)`}` : ''

    a.href = dataUrl
    a.download = _t('QR Code Vitrine Econômica {name}{suffix}.png', {name, suffix})
    document.body.appendChild(a)
    a.click()
    a.remove()
  }

  return (
    <Container style={{padding: 0}} direction="column">
      <Grid container spacing={3} direction="column" alignItems="center">
        <Grid item sm={12}>
          <Box marginTop="70px">
            <Box>
              <Button onClick={onGenerateShowcase} disabled={submiting}>
                {_`ATUALIZAR VITRINE ECONÔMICA`}
              </Button>
            </Box>
          </Box>
        </Grid>
        <Grid item sm={12}>
          <Box marginBottom="70px">
            {url && (
              <div className="d-flex flex-column" style={{gap: '15px'}}>
                <select className="form-control w-100" value={language} onChange={(e) => setLanguage(e.target.value)}>
                  <option value="pt">{_`Português`}</option>
                  <option value="en">{_`Inglês`}</option>
                </select>
                <Button
                  onClick={() => {
                    window.open(url)
                  }}
                  className="d-flex justify-content-between"
                  variant="outline-primary">
                  {_`Visualizar vitrine`} <i className="fas fa-external-link-alt"></i>
                </Button>
                <code>{url}</code>
                <div
                  className="d-flex flex-column justify-content-center align-items-center p-3 border rounded"
                  style={{gap: '6px'}}>
                  <QRCodeCanvas value={url} size={256} level="M" />

                  <Button onClick={onDownload} className="d-flex justify-content-between w-100" variant="light">
                    {_`BAIXAR QR CODE`} <i className="fas fa-download"></i>
                  </Button>

                  <div ref={canvasRef} className="d-none">
                    <QRCodeCanvas value={url} size={512} level="M" marginSize={2} />
                  </div>
                </div>
              </div>
            )}
          </Box>
        </Grid>
      </Grid>

      {snippets.map((snippet, idx) => (
        <details key={idx}>
          <summary>{snippet.title}</summary>
          {snippet.node}
        </details>
      ))}
    </Container>
  )
}

export default ShowcaseGenerator
